module.exports = __webpack_public_path__ + "img/gs1-qr-print-distance.fd296341.png";